import React, { useEffect, useState } from 'react';
import axios from 'axios';
import Navbar from "../../Navbar/Navbar.jsx";
import baseURL from '../../config.js';

const AssignedVesselTable = () => {
  const [vessels, setVessels] = useState([]);
  // const [crewingAgents, setCrewingAgents] = useState([]);
  useEffect(() => {
    const fetchVessels = async () => {
      try {
        const response = await axios.get(`${baseURL}/api/vesselformbyagent`);
        setVessels(response.data);
        
      } catch (error) {
        console.error('Error fetching vessel data:', error);
      }
    };

    fetchVessels();

  }, []);

  return (
    <>
      <Navbar />
      <div style={{ padding: '20px' }} className='assignedVesselTable'>
        <h2>Assigned Vessel and Crewing Agent</h2>
        <table style={{ width: '100%', borderCollapse: 'collapse' }}>
          <thead>
            <tr>
              <th style={{ border: '1px solid #ddd', padding: '8px', textAlign: 'left' }}>
                <strong>Vessel Info</strong>
              </th>
              <th style={{ border: '1px solid #ddd', padding: '8px', textAlign: 'left' }}>
                <strong>Crewing Agent</strong>
              </th>
            </tr>
          </thead>
          <tbody>
            {vessels.map((vessel, index) => (
              vessel?.selectedAgent ? (
                <tr key={vessel.id || index}>
                  <td style={{ border: '1px solid #ddd', padding: '8px' }}>
                    <div><strong>Employer:</strong> {vessel?.company_name?.company_name}</div>
                    <div><strong>IMO Number:</strong> {vessel.IMO_Number}</div>
                    <div><strong>Name of Ship:</strong> {vessel.vesselname}</div>
                  </td>
                  <td style={{ border: '1px solid #ddd', padding: '8px' }}>
                    <div><strong>Agent:</strong> {vessel?.selectedAgent?.agentName}</div>
                  </td>
                </tr>
              ) : null
            ))}
          </tbody>
        </table>
      </div>
    </>
  );
};

export default AssignedVesselTable;
